import api, { apiPrefix } from './Api';
import {
  RegisterRequest,
  registerRequestOutputTransformer,
} from '../interfaces/Auth/RegisterRequest';
import { ResetPasswordRequest } from '../interfaces/Auth/ResetPasswordRequest';
import {
  UserSummary,
  userSummaryFromResponse,
} from '../interfaces/User/UserSummary';
import {
  RenewPasswordRequest,
  renewPasswordRequestOutputTransformer,
} from '../interfaces/Auth/RenewPasswordRequest';

const authApiPrefix = `${apiPrefix}/auth/`;

export const getMe = async (): Promise<UserSummary> => {
  const response = await api.get(`${authApiPrefix}me`);

  return userSummaryFromResponse(response.data?.user);
};

export const login = async (
  username: string,
  password: string,
): Promise<string> => {
  const response = await api.post(`${authApiPrefix}login`, {
    email: username,
    password,
  });

  const token = response.data?.access_token;
  if (!token) {
    throw new Error('Could not login: empty token received from the API');
  }

  return token;
};

export const register = async (req: RegisterRequest): Promise<void> =>
  api.post(`${apiPrefix}/register`, registerRequestOutputTransformer(req));

export const forgotPassword = async (email: string): Promise<void> => {
  const bodyFormData = new FormData();
  bodyFormData.append('email', email);

  return api.post(`${apiPrefix}/forgot-password`, bodyFormData);
};

export const renewPassword = async (req: RenewPasswordRequest): Promise<void> =>
  api.post(
    `${apiPrefix}/password/renewPassword`,
    renewPasswordRequestOutputTransformer(req),
  );

export const resetPassword = async (
  req: ResetPasswordRequest,
): Promise<void> => {
  const bodyFormData = new FormData();
  bodyFormData.append('new_password', req.password);

  return api.post(
    `${apiPrefix}/password/reset/${req.email}/${req.code}`,
    bodyFormData,
  );
};
